export enum SpeedUnit {
    MetersPerSec,
    KilometersPerHour,
    MilesPerHour,
    YardsPerSec
}
